module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_7042.012cb974.png";